export default __webpack_public_path__ + "static/media/MO_icon.a2c32d93.webp";